import { Link } from 'react-router-dom';
import { ReactNode } from 'react';

export type BreadcrumbItem = {
  label: ReactNode;
  to?: string;
};

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav
      className="mb-4 flex items-center gap-1.5 text-[13px] text-text-secondary"
      aria-label="Fil d'Ariane"
    >
      {items.map((it, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={i} className="flex items-center gap-1.5">
            {i > 0 && <span className="text-[12px] text-text-tertiary">›</span>}
            {it.to && !isLast ? (
              <Link to={it.to} className="text-text-link hover:underline">
                {it.label}
              </Link>
            ) : (
              <span className={isLast ? 'text-text-primary' : ''}>{it.label}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
